// Anzeige der Pflichtattribut-Prüfung (OTTO featureRelevance LEGAL).
//
// Die Prüfung selbst macht otto-listing-preview (_shared/otto-required-attributes.ts) und hält das
// Ergebnis am Listing fest (otto.listings.required_attrs_*). Hier nur die Darstellung: oben im
// Detailbereich als Statuszeile, im Lister als kleiner Chip. Fehlende Attribute sind eine Warnung,
// der Push bleibt möglich.

import { escapeHtml } from '../tabs/otto-list-mapping.js';

export interface RequiredAttrsSummary {
  total: number;
  missing: string[];
}

/** Statuszeile im Detailbereich. Die fehlenden Namen sind Links (data-req-attr) auf die Mapping-Zeile. */
export function renderRequiredAttrsLine(s: RequiredAttrsSummary | null, state: 'loading' | 'ready' | 'error' = 'ready'): string {
  if (state === 'loading') {
    return `<div class="kl-statusline kl-statusline--muted"><span class="kl-statusline-ic v-icon fa-light fa-spinner-third fa-spin"></span><div>Pflichtattribute werden geprüft…</div></div>`;
  }
  if (state === 'error' || !s) {
    return `<div class="kl-statusline kl-statusline--muted"><span class="kl-statusline-ic v-icon fa-light fa-circle-question"></span><div>Pflichtattribute konnten nicht geprüft werden.</div></div>`;
  }
  if (s.total === 0) {
    return `<div class="kl-statusline kl-statusline--muted"><span class="kl-statusline-ic v-icon fa-light fa-circle-info"></span><div>Die OTTO-Kategorie hat keine Pflichtattribute.</div></div>`;
  }
  const filled = s.total - s.missing.length;
  if (s.missing.length === 0) {
    return `<div class="kl-statusline"><span class="kl-statusline-ic v-icon fa-light fa-circle-check"></span><div><b>Pflichtattribute vollständig</b> (${s.total} von ${s.total} gepflegt)</div></div>`;
  }
  const links = s.missing
    .map((n) => `<a href="#" class="otto-req-attr-link" data-req-attr="${escapeHtml(n)}">${escapeHtml(n)}</a>`)
    .join(', ');
  return `<div class="kl-statusline kl-statusline--warn"><span class="kl-statusline-ic v-icon fa-light fa-triangle-exclamation"></span><div><b>Pflichtattribute: ${filled} von ${s.total} gepflegt.</b> Es fehlt: ${links}</div></div>`;
}

/** Chip im Lister. Ohne bisherige Prüfung (total null) kein Chip. */
export function renderRequiredAttrsPill(total: number | null | undefined, missing: string[] | null | undefined): string {
  if (total == null || total === 0) return '';
  const m = missing ?? [];
  if (m.length === 0) return '';
  const title = `Pflichtattribute fehlen: ${m.join(', ')}`;
  return `<span class="pill req-pill" title="${escapeHtml(title)}">${total - m.length}/${total} Pflichtattr.</span>`;
}
